import React from "react";
import "./style.css";

export default function Rodape() {
  return (
    <footer>
      <div>
        <p>
          Desenvolvido por <span>Guilherme de Souza</span>{" "}
        </p>
      </div>
    </footer>
  );
}
